var myInterval;

jQuery(document).ready(function ($) {
    var randomValue = Math.floor(Math.random() * 99999);
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            listFlights(this);
        }
    };
    xhttp.open("GET", "/wp-content/themes/skavsta/flights/fids.xml?" + randomValue, true);
    xhttp.send();

    $(".flights-btn").each(function () {
        $(this).on("click", function () {
            $('.flights-btn').removeClass('active');
            $('#div-warning').removeClass('hidden');
            $(this).addClass('active');
            if ($(this).hasClass('arrivals')) {
                $('.flights-table-row.flights-table-head').show();
                $('.flightDepartures').hide();
                $('.flightArrivals').show();
            } else if ($(this).hasClass('departures')) {
                $('.flights-table-row.flights-table-head').show();
                $('.flightArrivals').hide();
                $('.flightDepartures').show();
            }
        });
    });
    
    $('#arrivals .arrivals').trigger("click");
    
    var flightFavoriteData = getFavoriteFlight("favoriteFlight");
    if (flightFavoriteData) {
        myInterval = setInterval(fetchFlightData, 10000);
    }
});



function fetchFlightData() {
    var flightFavoriteData = getFavoriteFlight("favoriteFlight");
    var flightNrValue = flightFavoriteData.flightNr;
    var flightAirlineValue = flightFavoriteData.airline;
    var flightAirportValue = flightFavoriteData.airport;
    var flightTimeValue = flightFavoriteData.time;
    var flightStatusValue = flightFavoriteData.status;
    var flightGateValue = flightFavoriteData.gate;

    //console.log("Check for changes");

    var randomValue1 = Math.floor(Math.random() * 99999);
    var xhttp1 = new XMLHttpRequest();
    xhttp1.onreadystatechange = function () {
        //console.log(this.readyState);
        //console.log(this.status);
        if (this.readyState == 4 && this.status == 200) {
            var xmlDoc1 = this.responseXML;
            var nod = $(xmlDoc1).find("flight iata:contains('" + flightNrValue + "')");
            // TODO: Finns det ingen tr�ff i datan s� tar vi bort cookie

            if (nod) {
                var pNod = nod.parent();
                //var _iata = pNod.find('iata')[0];
                var _remark = pNod.find('remark')[0].getElementsByTagName('name')[0];
                var _scheduledtime = pNod.find('scheduledtime')[0];
                //console.log("pNod: " + pNod);
                var _tmpgate = pNod.find('gate')[0];
                //console.log("_tmpgate: " + _tmpgate);
                var _gate = "";
                if (_tmpgate) {
                    _gate = 'Gate: ' + _tmpgate.textContent;
                }

                //console.log("flightStatusValue: " + flightStatusValue);
                //console.log("_remark: " + _remark.textContent);
                //console.log("flightTimeValue: " + flightTimeValue);
                //console.log("_scheduledtime: " + _scheduledtime.textContent);
                //console.log("_gate: " + _gate);

                if (flightTimeValue != _scheduledtime.textContent || flightStatusValue != _remark.textContent || flightGateValue != _gate) {
                    //console.log("Flight has changed!");
                    createFavoriteFlight("favoriteFlight", flightNrValue, flightAirlineValue, flightAirportValue, _scheduledtime.textContent, _remark.textContent, _gate, 1);
                    showFavoriteData(flightNrValue, flightAirlineValue, flightAirportValue, _scheduledtime.textContent, _remark.textContent, _gate, true);

                    $containerArrivals = jQuery('.flightArrivals');
                    $containerDepartures = jQuery('.flightDepartures');
                    if ($containerDepartures || $containerArrivals) {
                        $containerDepartures.empty();
                        $containerArrivals.empty();
                        listFlights(this);
                    }
                                        
                }
                //console.log(_iata.textContent);
            }
        }
    };
    xhttp1.open("GET", "/wp-content/themes/skavsta/flights/fids.xml?" + randomValue1, true);
    xhttp1.send();
}


function listFlights(xml) {
    var xmlDoc = xml.responseXML;

    var flights = xmlDoc.getElementsByTagName('flights')[0].childNodes;

    var departures = [];
    var arrivals = [];

    var containers = {
        $departures: jQuery('.flightDepartures'),
        $arrivals: jQuery('.flightArrivals')
    };

    var flightFavoriteData = getFavoriteFlight("favoriteFlight");
    var flightNrValue = flightFavoriteData.flightNr;
    //var flightAirportValue = flightFavoriteData.airport;
    var flightTimeValue = flightFavoriteData.time;
    var flightStatusValue = flightFavoriteData.status;
    var flightGateValue = flightFavoriteData.gate;
    
    for (var i = 0, flight, $container; i < flights.length; i++) {
        var tmpFlightNr = "";
        var tmpAirport = "";
        var tmpTime = "";
        var tmpStatus = "";
        var tmpGate = "";

        flight = flights[i];
        var typeNode = flight.getElementsByTagName('type')[0];
        if(typeNode == null) {
            continue;
        }

        var type = typeNode.childNodes[0].nodeValue;

        if (type === 'arrival')
            $container = containers.$arrivals;
        else
            $container = containers.$departures;

        var flightNr = flight.getElementsByTagName('iata')[0].childNodes;
        var airline = flight.getElementsByTagName('airline')[0].getElementsByTagName('name')[0].childNodes;
        var airport = flight.getElementsByTagName('airport')[0].getElementsByTagName('name')[0].childNodes;
        var time = flight.getElementsByTagName('scheduledtime')[0].childNodes;
        var status = flight.getElementsByTagName('remark')[0].getElementsByTagName('name');
        var gate = null;
        if (flight.getElementsByTagName('gate')[0]) {
            gate = flight.getElementsByTagName('gate')[0].childNodes;
        }

        var row = jQuery('<div class="flights-table-row" />');
        var $flightContainer = jQuery('<div class="flights-table-row-inner" />');

        if (flightNr.length >= 1) {
            tmpFlightNr = flightNr[0].nodeValue;
        }

        if (airline.length >= 1) {
            tmpAirline = airline[0].nodeValue;
        }

        if (airport.length >= 1) {
            tmpAirport = airport[0].nodeValue;
        }

        if (time.length >= 1) {
            tmpTime = time[0].nodeValue;
        }

        if (status.length >= 1) {
            tmpStatus = status[0].childNodes[0].nodeValue;
        }

        if (gate) {
            if (gate.length > 0) {
                tmpGate = 'Gate: ' + gate[0].nodeValue;
            }
        }

        $flightContainer.append('<div class="flight-col">' + tmpFlightNr + '</div>');
        $flightContainer.append('<div class="flight-col">' + tmpAirline + '</div>');
        $flightContainer.append('<div class="flight-col">' + tmpAirport + '</div>');
        $flightContainer.append('<div class="flight-col">' + tmpTime + '</div>');
        $flightContainer.append('<div class="flight-col">' + tmpStatus + ' ' + tmpGate + '</div>');
                
        if (flightNrValue == flightNr[0].nodeValue) {

            //console.log("Flight:" + tmpFlightNr + ", flightTimeValue:" + flightTimeValue + ", flightStatusValue:" + flightStatusValue + ", flightGateValue:" + flightGateValue);
            //console.log("Flight:" + tmpFlightNr + ", tmpTime:" + tmpTime + ", tmpStatus:" + tmpStatus + ", tmpGate:" + tmpGate);

            var hasChanges = false;
            $flightContainer.append('<div class="flight-favorites-btn"><a class="icon-star2" data-flightnr="' + tmpFlightNr + '" data-airport="' + tmpAirport + '" data-time="' + tmpTime + '" data-status="' + tmpStatus + ' data-gate="' + tmpGate + '"></a></div>');
            if (tmpTime != flightTimeValue || tmpStatus != flightStatusValue || tmpGate != flightGateValue) {
                hasChanges = true;
                createFavoriteFlight("favoriteFlight", tmpFlightNr, tmpAirline, tmpAirport, tmpTime, tmpStatus, tmpGate, 1);
                showFavoriteData(tmpFlightNr, tmpAirline, tmpAirport, tmpTime, tmpStatus, tmpGate, true);
            }
            else {
                showFavoriteData(tmpFlightNr, tmpAirline, tmpAirport, tmpTime, tmpStatus, tmpGate, false);
            }
            
            //console.log("Flight:" + tmpFlightNr + ", hasChanges:" + hasChanges);
        } else {
            $flightContainer.append('<div class="flight-favorites-btn"><a class="icon-star1" data-flightnr="' + tmpFlightNr + '" data-airline="' + tmpAirline + '" data-airport="' + tmpAirport + '" data-time="' + tmpTime + '" data-status="' + tmpStatus + '" data-gate="' + tmpGate + '"></a></div>');
        }
              
        row.append($flightContainer);
        $container.append(row);
    }

    jQuery(".icon-star1").each(function () {
        jQuery(this).on("click", function () {
            var clickedItem = $(this);

            $('.icon-star2').each(function () {
                $(this).removeClass("icon-star2");
                $(this).addClass("icon-star1");
            })

            clickedItem.removeClass("icon-star1");
            clickedItem.addClass("icon-star2");
            //clickedItem.attr("id", "remove-favorite-2");

            var data_flightNrValue = clickedItem.data("flightnr");
            var data_airlineValue = clickedItem.data("airline");
            var data_airportValue = clickedItem.data("airport");
            var data_timeValue = clickedItem.data("time");
            var data_statusValue = clickedItem.data("status");
            var data_gateValue = clickedItem.data("gate");
            createFavoriteFlight("favoriteFlight", data_flightNrValue, data_airlineValue, data_airportValue, data_timeValue, data_statusValue, data_gateValue, 1);

            showFavoriteData(data_flightNrValue, data_airlineValue, data_airportValue, data_timeValue, data_statusValue, data_gateValue, false);
        });
    });

    //$(document).on('click', '#remove-favorite-2', function () {
    //    $('.icon-star2').each(function () {
    //        $(this).removeClass("icon-star2");
    //        $(this).addClass("icon-star1");
    //        $(this).removeAttr("id", "remove-favorite-2");
    //    })
    //    removeFavoriteFlight("favoriteFlight");
    //});

    jQuery(document).on('click', '#remove-favorite-1', function () {
        jQuery('.icon-star2').each(function () {
            $(this).removeClass("icon-star2");
            $(this).addClass("icon-star1");
        })
        removeFavoriteFlight("favoriteFlight");
    });
}

function showFavoriteData(flightNr, airline, airport, time, status, gate, hasChanges) {
    var containers = {
        $favorite: jQuery('.flightFavorite')
    };

    $container = jQuery('.flightFavorite');

    $container.empty();
        
    var row = jQuery('<div class="flights-table-row" />');
    var $flightContainer = jQuery('<div class="flights-table-row-inner" />');

    if (flightNr.length >= 1) {
        $flightContainer.append('<div class="flight-col">' + flightNr + '</div>');
    }

    if (airline.length >= 1) {
        $flightContainer.append('<div class="flight-col">' + airline + '</div>');
    }

    if (airport.length >= 1) {
        $flightContainer.append('<div class="flight-col">' + airport + '</div>');
    }

    if (time.length >= 1) {
        $flightContainer.append('<div class="flight-col">' + time + '</div>');
    }

    if (status.length >= 1) {
        $flightContainer.append('<div class="flight-col">' + status + ' ' + gate + '</div>');
    }

    $flightContainer.append('<div class="flight-favorites-btn"><a class="icon-star2" id="remove-favorite-1"></a></div>');

    row.append($flightContainer);
    $container.append(row);

    //console.log("showFavoriteData - hasChanges:" + hasChanges);

    if (hasChanges) {
        $container.addClass("has-changed");
        setTimeout(function () { $container.removeClass("has-changed"); }, 6000);
    }
}

function createFavoriteFlight(cname, flightNrValue, airlineValue, airportValue, timeValue, statusValue, gateValue, expireDays) {
    //console.log("createFavoriteFlight: " + flightNrValue + ", airportValue:" + airportValue + ", timeValue:" + timeValue + ", statusValue:" + statusValue + ", gateValue:" + gateValue)
    var d = new Date();
    d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    var flightData = { flightNr: "" + flightNrValue + "", airline: "" + airlineValue + "", airport: "" + airportValue + "", time: "" + timeValue + "", status: "" + statusValue + "", gate: "" + gateValue + "" };
    document.cookie = cname + "=" + JSON.stringify(flightData) + ";" + expires + ";path=/";
    
    //console.log("myInterval: " + myInterval)

    clearInterval(myInterval);

    myInterval = setInterval(fetchFlightData, 10000);
}

function removeFavoriteFlight(cname) {
    document.cookie = cname + "=;" + "Thu, 01 Jan 1970 00:00:00 UTC" + ";path=/";
    $container = jQuery('.flightFavorite');
    $container.empty();

    clearInterval(myInterval);
}

function getFavoriteFlight(cname) {
    var flightData = getCookie(cname);
    if (flightData) {
        try {
            var obj = JSON.parse(flightData);

            if (obj != "") {
                return obj;
            }
        }
        catch (err) {
            //console.log(err.message);
            return "";
        }
    }
    return "";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function hasClass(elem, className) {
    return elem.classList.contains(className);
}

